module.exports = {
    title: "User Titles",
    crud: {
        create: "Create User Title",
        edit: "Edit User Title",
    },
    table: {
        title: "Title",
        industry: "Industry",
    },
    form: {
        title: "Title",
        industry: "Industry",
    },
    validation: {
        required: {
            title: 'Title is required',
            industry: 'Industry is required',
        },
        minLength: {
            title: 'Title must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}
